const GROUPS_WHERE_GROWTH_NEEDS_ATTENTION = new Set([
  "unsubscribed",
  "idle customers",
  "cart abandoners",
  "indecisive buyers",
  "one timers",
  "likely to churn in 5 months",
]);

export const groupNeedsAttention = (groupName: string, changePercent: number): boolean =>
  GROUPS_WHERE_GROWTH_NEEDS_ATTENTION.has(groupName.trim().toLowerCase())
    ? changePercent > 0
    : changePercent < 0;
